<template>
  <div class="file-manager">
    <div class="left">
      <a class="logo">
        <img src="../assets/images/adam-logo.png" alt />
      </a>
      <div class="nav">
        <div
          class="nav-item"
          @click="changeNav(index)"
          v-for="(item, index) in navList"
          :class="{ active: index === navIndex }"
          :key="index"
        >
          <i :class="item.className"></i>
          <p>{{ item.name }}</p>
        </div>
      </div>
      <div class="folder-list">
        <h3 class="title">文件夹</h3>
        <folder-tree-item
          @toFolder="toFolder"
          v-for="(item, index) in treeList"
          :key="index"
          :item="item"
        ></folder-tree-item>
      </div>
    </div>

    <!-- right -->
    <div class="right">
      <div class="header">
        <el-popover placement="bottom" width="120" trigger="click">
          <div class="info" slot="reference">
            <div class="avatar">
              <img src alt />
            </div>
            <p class="name">{{ userInfo.name }}</p>
            <i href class="more"></i>
          </div>
          <div class="logout">
            <!-- <div class="logout-item" @click.stop="toFeatures">功能介绍</div> -->
            <div class="logout-item" @click.stop="logoutConfirm">退出登录</div>
          </div>
        </el-popover>
      </div>
      <div class="main">
        <folder-list
          :folderIndex="folderId"
          :folderPath="folderPath"
          :update="allFileCount"
          v-show="navIndex === 0"
        ></folder-list>
        <label-list :update="labelCount" v-show="navIndex === 1"></label-list>
      </div>
    </div>
  </div>
</template>
<script>
import { getFolderList, getFolderTreeList } from "../assets/js/api";
import { PromiseWidget } from "../assets/js/tools";
import FolderList from "../components/FolderList";
import LabelList from "../components/LabelList";
import FolderTreeItem from "../components/FolderTreeItem";
export default {
  components: { FolderList, LabelList, FolderTreeItem },
  data() {
    return {
      navList: [
        {
          className: "folder",
          name: "全部素材"
        },
        {
          className: "label",
          name: "标签管理",
          url: "/"
        }
      ],
      count: 0,
      folderId: -1,
      navIndex: 0,
      treeList: [],
      folderPath: [],
      labelCount: 0,
      userInfo: {},
      allFileCount: 0
    };
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.getFolderTreeList();
  },
  mounted() {},
  methods: {
    logoutConfirm() {
      localStorage.menuList = "[]";
      localStorage.token = "";
      this.$router.push("/login");
    },
    changeNav(index) {
      this.navIndex = index;
      if (this.navIndex === 0) {
        this.folderId = -1;
        this.count += 1;
        this.allFileCount++;
      } else {
        this.labelCount += 1;
      }
    },
    toFolder(payload) {
      this.folderId = payload.item.id;
      this.navIndex = 0;
      if (payload.parentNode) {
        payload.parentNode.unshift(payload.item);
      } else {
        payload.parentNode = [payload.item];
      }

      const temp = payload.parentNode.reverse(),
        tmp = [];
      temp.unshift({ name: "全部", id: -1 });
      temp.map(item => {
        tmp.push({ name: item.name, index: item.id });
      });

      this.folderPath = tmp;
    },
    async getFolderTreeList() {
      const [err, data] = await PromiseWidget.to(getFolderTreeList());
      if (data.code === 200) {
        data.data.map(item => {
          item.children.map(it => {
            it.active = false;
          });
        });
        this.treeList = data.data;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.file-manager {
  height: 100%;
  width: 100%;
  background-color: #fff;

  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  .left {
    width: 240px;
    height: 100vh;
    background-color: #f4f4f4;
    padding: 12px 0;
    box-sizing: border-box;

    .logo {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 200px;
      margin: 0 auto;
      padding-bottom: 12px;
      border-bottom: 1px solid #dcdfe6;
    }

    .nav {
      padding: 20px 0;
      .nav-item {
        padding: 0 34px;
        height: 40px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
        &:hover {
          background-color: #eaeaea;
        }

        &.active {
          p {
            color: #1983f9;
          }

          i {
            &.label {
              background-image: url(../assets/images/label-active-icon.png);
            }
            &.folder {
              background-image: url(../assets/images/folder-active-icon.png);
            }
          }
        }
        i {
          width: 18px;
          height: 18px;
          background-size: 18px 18px;
          &.folder {
            background-image: url(../assets/images/folder.png);
          }
          &.label {
            background-image: url(../assets/images/label.png);
          }
        }
        p {
          margin: 0;
          color: #606266;
          font-size: 16px;
          margin-left: 20px;
        }
      }
    }

    .folder-list {
      h3.title {
        border-top: 1px solid #dcdfe6;
        margin: 0 20px;
        padding: 10px 0;
        font-size: 12px;
        color: #1983f9;
        text-align: left;
        font-weight: 400;
      }
    }
  }

  .right {
    width: 100%;
    height: 100vh;
    .header {
      width: 100%;
      height: 60px;
      box-shadow: 0px 2px 10px rgba(34, 73, 100, 0.05);
      position: relative;
      z-index: 2;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .info {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        margin-right: 20px;
        cursor: pointer;

        .avatar {
          width: 30px;
          height: 30px;
          background-color: #a6dbff;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            max-width: 100%;
            max-height: 100%;
          }
        }

        p.name {
          margin-left: 8px;
          color: #909399;
          font-size: 16px;
        }

        i.more {
          width: 15px;
          height: 10px;
          background: url(../assets/images/more-icon.png) no-repeat;
          margin-left: 4px;
        }
      }
    }

    .main {
      height: calc(100% - 60px);
      box-sizing: border-box;
    }
  }
}
</style>